<template>
  <layout-main-inner title="人员管理">
    <div slot="action">
      <el-button
        type="primary"
        @click="additem">
        新增人员
      </el-button>
    </div>
    <layout-card-wrap hasSlot>
      <div slot="form">
        <el-select
          v-model="config.num"
          style="width:170px"
          placeholder="请选择核对数">
          <el-option
            :key="1"
            label="核对数小于1000"
            value="0-999">
          </el-option>
          <el-option
            :key="2"
            label="核对数大于等于1000"
            value="1000-">
          </el-option>
        </el-select>
        <el-input
          v-model="config.userName"
          style="margin-left: 10px;width:200px"
          clearable
          placeholder="请输入姓名"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </div>
      <el-table
        border
        :data="list">
        <el-table-column
          label="姓名"
          min-width="140"
          prop="userName">
        </el-table-column>
        <el-table-column
          label="手机号"
          width="180"
          prop="mobilePhone">
        </el-table-column>
        <el-table-column
          label="身份证"
          width="240"
          prop="idCertNo">
        </el-table-column>
        <el-table-column
          label="核对数量"
          width="140"
          prop="luxuryIdentificationTimes">
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="150">
          <template slot-scope="{ row }">
            <span>{{ row.createdTime | dateformat() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="100">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="updateitem(row)">编辑</el-button>
            <el-button
              type="text"
              @click="deleteitem(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange">
      </el-pagination>
    </layout-card-wrap>
    <edit-user-modal
      ref="user"
      :callback="() => { getlist() }"
    />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import EditUserModal from './edit-user-modal.vue'
import Common from '@/service/common'
export default {
  name: 'LuxuryUsersIndex',
  components: { EditUserModal },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        courseExamName: '',
        num: '0-999'
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    updateitem(row) {
      this.$refs.user.update({
        userId: row.userId,
        userName: row.userName,
        mobilePhone: row.mobilePhone,
        idCertNo: row.idCertNo,
        luxuryIdentificationTimes: row.luxuryIdentificationTimes
      })
    },
    additem() {
      this.$refs.user.add(this.userInfo.orgId)
    },
    deleteitem(row) {
      console.log(row)
      this.$confirm('您确定删除该人员?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Common.deleteuser({ userId: row.userId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.getlist()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        // this.loading = true
        // this.$store.dispatch('account/deletecourseexam', {
        //   payload: {
        //     userId: row.userId
        //   },
        //   success: () => {
        //     this.loading = false
        //     this.getlist()
        //   },
        //   fail: () => {
        //     this.loading = false
        //   }
        // })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      const num = this.config.num.split('-')
      this.$store.dispatch('account/getusers', {
        payload: {
          ...this.config,
          beginIdentificationTimes: num[0],
          endIdentificationTimes: num[1]
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            return {
              ...i,
              userCount: i.passedUserCount + i.notPassedUserCount
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
